import { alert, hideLoader, showLoader } from "../plugins";
import { createAsyncAction } from "../utils/ajex";
import Services from "../api/services";
import * as aj from "../aj/index";
import M from "../strings";
import * as _query from "../framework/query";
import { SET_WEIGHT, SET_NOTES, LOAD_SURVEY_TEMPLATE_WEIGHTS, ASSOCIATE_QUESTION_TEMPLATE_IDS, LOAD_SURVEY_TEMPLATE_CATEGORIES, LOAD_CATEGORY_NODES as LOAD_CATEGORIES_NODES, SELECT_CATEGORY, DESELECT_CATEGORY, SET_SELECTED_CATEGORY_IDS, CLEAR_CATEGORIES, LOAD_CATEGORIES_QUESTIONS_TREE, SELECT_QUESTION_TEMPLATE, DESELECT_QUESTION_TEMPLATE, LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS, UPDATE_WEIGHTS, LOAD_DEFAULT_SURVEY_NOTES, INIT_PRESENTATION_NOTES } from "./types";
import * as responses from "../api/responses";
import { polish } from "../utils/lang";
import { CategoriesStore } from "../stores/categories";


export const loadCategoryNodes = createAsyncAction(LOAD_CATEGORIES_NODES, data => {
    aj.dispatch({
        type: LOAD_CATEGORIES_NODES
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get("categories/nodes")
            .then((response) => {
                loadCategoryNodes.complete({
                    categoryNodes: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadCategoryNodes.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const loadSurveyTemplateWeights = createAsyncAction(LOAD_SURVEY_TEMPLATE_WEIGHTS, data => {
    aj.dispatch({
        type: LOAD_SURVEY_TEMPLATE_WEIGHTS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get("categories/weights?surveyTemplateId=" + data.surveyTemplateId)
            .then((response) => {
                loadSurveyTemplateWeights.complete({
                    weights: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadSurveyTemplateWeights.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const updateWeights = createAsyncAction(UPDATE_WEIGHTS, data => {
    aj.dispatch({
        type: UPDATE_WEIGHTS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.postJson("categories/weights?surveyTemplateId=" + data.surveyTemplateId, data.weights)
            .then((response) => {
                updateWeights.complete();
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                updateWeights.fail();
                reject();
            })
            .finally(hideLoader)
    })
});


export const loadCategoriesQuestionsTree = createAsyncAction(LOAD_CATEGORIES_QUESTIONS_TREE, data => {
    aj.dispatch({
        type: LOAD_CATEGORIES_QUESTIONS_TREE
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.postJson("categories/questions-tree", data.categoryIds)
            .then((response) => {
                loadCategoriesQuestionsTree.complete({
                    questionsTree: response.value,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadCategoriesQuestionsTree.fail();
                reject();
            })
            .finally(hideLoader)
    })
});


export const loadDefaultSurveyNotes = createAsyncAction(LOAD_DEFAULT_SURVEY_NOTES, data => {
    aj.dispatch({
        type: LOAD_DEFAULT_SURVEY_NOTES
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get("export/surveys/" + data.surveyId + "/presentations/default-notes")
            .then((response) => {
                loadDefaultSurveyNotes.complete({
                    presentationNotes: response.value.presentationNotes,
                    questionsTree: response.value.questionsTree,
                });
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadDefaultSurveyNotes.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const loadSurveyTemplateCategories = createAsyncAction(LOAD_SURVEY_TEMPLATE_CATEGORIES, data => {
    aj.dispatch({
        type: LOAD_SURVEY_TEMPLATE_CATEGORIES
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.get(`surveys/templates/${data.surveyTemplateId}/categories`)
            .then((response) => {
                loadSurveyTemplateCategories.complete({
                    categoryIds: response.value,
                });
                resolve(response.value);
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadSurveyTemplateCategories.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const loadAssociatedQuestionTemplateIds = createAsyncAction(LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS, data => {
    aj.dispatch({
        type: LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.postJson(`surveys/templates/${data.surveyTemplateId}/question-template-ids`, data.categoryIds)
            .then((response) => {
                loadAssociatedQuestionTemplateIds.complete({
                    questionTemplateIds: response.value,
                });
                resolve(response.value);
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                loadAssociatedQuestionTemplateIds.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const associateQuestionTemplateIds = createAsyncAction(ASSOCIATE_QUESTION_TEMPLATE_IDS, data => {
    aj.dispatch({
        type: ASSOCIATE_QUESTION_TEMPLATE_IDS
    })

    return new Promise((resolve, reject) => {
        showLoader();
        Services.postJson(`surveys/templates/${data.surveyTemplateId}/question-template-ids/update`, data.questionTemplateIds)
            .then((response) => {
                associateQuestionTemplateIds.complete();
                resolve();
            })
            .catch(e => {
                alert(M("ooops"), responses.msg(e), "error");
                associateQuestionTemplateIds.fail();
                reject();
            })
            .finally(hideLoader)
    })
});

export const selectCategory = (category) => aj.dispatch({type: SELECT_CATEGORY, category})
export const setSelectedCategoryIds = (selectedCategoryIds) => aj.dispatch({type: SET_SELECTED_CATEGORY_IDS, selectedCategoryIds})
export const deselectCategory = (category) => aj.dispatch({type: DESELECT_CATEGORY, category})
export const clearCategories = () => aj.dispatch({type: CLEAR_CATEGORIES})
export const selectQuestionTemplate = (node) => aj.dispatch({type: SELECT_QUESTION_TEMPLATE, node})
export const deselectQuestionTemplate = (node) => aj.dispatch({type: DESELECT_QUESTION_TEMPLATE, node})
export const setWeight = (categoryId, value) => aj.dispatch({type: SET_WEIGHT, categoryId, value})
export const setNotes = (categoryId, value) => aj.dispatch({type: SET_NOTES, categoryId, value})
export const initPresentationNotes = (presentationNotes) => aj.dispatch({type: INIT_PRESENTATION_NOTES, presentationNotes})
